import React from 'react'
import { useTranslation } from 'react-i18next'
import MainIcon from '../../../../../img/svg/main'
import { ModalButtonContent, ModalButtonWrap } from '../../ButtonsModal/index.styled'
import { MarkReadyButtonWrap, MarkReadyDots, MarkReadyStatusRow } from './index.styled'

const MarkReadyButton = React.memo(({ order, status, index, isActive, isDisabled, onClick }) => {
	const { t } = useTranslation()
	const markedReady = order?.platformMetaData?.markedReady === true

	const isPending = status === 'pending'
	const isSucceeded = status === 'succeeded'
	const isError = status === 'error'
	const isCompleted = isSucceeded || markedReady

	const buttonWrapLayout = (isPending ? 'pending ' : '') + (isSucceeded ? 'succeeded ' : '') + (isError ? 'error ' : '')
	const buttonLayout = ((isActive) ? 'active ' : '') + (isDisabled ? 'disabled ' : '')

	return (
		<MarkReadyButtonWrap className={buttonWrapLayout}>
			<ModalButtonContent>
				<ModalButtonWrap type="button"
				                 tabIndex={index}
				                 onClick={onClick}
				                 disabled={isDisabled}
				                 className={buttonLayout}>
					<MainIcon icon={isCompleted ? 'checkmark' : 'give-courier'} />
					{t('order.modal.mark_ready')}
				</ModalButtonWrap>
				{isPending &&
					<MarkReadyStatusRow>
						<MarkReadyDots><span /><span /><span /></MarkReadyDots>
						{t('order.modal.mark_ready_pending')}
					</MarkReadyStatusRow>}
				{isSucceeded &&
					<MarkReadyStatusRow className="success">
						<MainIcon icon="checkmark" />
						{t('order.modal.mark_ready_success')}
					</MarkReadyStatusRow>}
				{isError &&
					<MarkReadyStatusRow className="error">
						<MainIcon icon="error" />
						{t('order.modal.mark_ready_error')}
					</MarkReadyStatusRow>}
			</ModalButtonContent>
		</MarkReadyButtonWrap>
	)
})

MarkReadyButton.displayName = 'MarkReadyButton'
export default MarkReadyButton
